import { useEffect } from 'react';
import {
  TechDocsReaderPageContent,
  TechDocsReaderPageSubheader,
} from '@backstage/plugin-techdocs';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';

export const TechDocsCustomLayout = () => {
  const { title, entityMetadata } = useTechDocsReaderPage();
  const BASE_TITLE = 'Documentation | Arla Foods Developer Portal';

  useEffect(() => {
    const entityName =
      entityMetadata.value?.metadata.title ||
      entityMetadata.value?.metadata.name;

    document.title = `${entityName} | ${BASE_TITLE}`;
  }, [title, entityMetadata]);

  return (
    <>
      <TechDocsReaderPageSubheader />
      <TechDocsReaderPageContent />
    </>
  );
};
